import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import ExternalLink from '../../icons/external-link.svg';

const MobileLink = (props) => {
  const { to, href, label } = props;

  let linkProps = {};

  if (href) {
    linkProps = { href, target: '_blank', rel: 'noreferrer', as: 'a' };
  } else if (to) {
    linkProps = { to };
  } else {
    linkProps = { as: 'button' };
  }

  return (
    <LinkWrapper>
      <StyledLink
        // eslint-disable-next-line
        {...linkProps}
      >
        {label} {href && <StyledExternalLink />}
      </StyledLink>
    </LinkWrapper>
  );
};

const LinkWrapper = styled.div`
  padding-left: 20px;
  margin-bottom: 20px;
  display: block;
`;

const StyledLink = styled(Link)`
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
`;

const StyledExternalLink = styled(ExternalLink)`
  margin-left: 10px;
`;

export default MobileLink;
